"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@ungap/custom-elements");
const dropdown_navigation_1 = __importDefault(require("./components/dropdown-navigation"));
const accordion_menu_1 = __importDefault(require("./components/accordion-menu"));
const toggle_1 = __importDefault(require("./components/toggle"));
const header_carousel_1 = __importDefault(require("./components/header-carousel"));
require("./styles/core.css");
customElements.define('compleat-menu', dropdown_navigation_1.default, {
    extends: 'ul',
});
customElements.define('compleat-accordion-menu', accordion_menu_1.default, {
    extends: 'li',
});
customElements.define('compleat-toggle-button', toggle_1.default, {
    extends: 'button',
});
customElements.define('compleat-header-carousel', header_carousel_1.default, {
    extends: 'div',
});
